import { Button, Typography, Paper, List, ListItem, ListItemIcon, Checkbox, ListItemText, RadioGroup, FormControlLabel, Radio, Accordion, AccordionSummary, AccordionDetails, Tooltip, CircularProgress } from '@material-ui/core';
import { ArrowForward, ExpandMore, Refresh, ArrowBack, Explore, TextRotationNone, KeyboardTab } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { getDistrictName, stripIdFromStaffName } from '../../../../utilities/common';
import { getDirections } from '../../../../actions/mmActions';
import { showAlertSnackbar } from '../../../../reducers/uiSlice';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme)=> ({
    root: {
        display: 'flex', 
        flexDirection: 'column', 
        height: '100%'
    },
    center: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 50
    }
}))

function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
    let result = a.filter((value) => b.indexOf(value) !== -1);
    return result
}

function TransferList(props){
    const {t} = useTranslation('mapManagement');
    const [checked, setChecked] = useState([]);
    const [leftList, setLeftList] = useState([]);
    const [rightList, setRightList] = useState([]);
    const [staffValue, setStaffValue] = useState(getDefaultAccount(props.accounts));

    const leftChecked = intersection(checked, leftList);
    const rightChecked = intersection(checked, rightList);

    useEffect(() => {
        props.onListChange(leftList, rightList)
    }, [leftList, rightList])

    useEffect(()=> {
        if (leftList.length <= 0 || rightList.length <= 0){
            setLeftList(props.transferList)
        }
    }, [props.transferList])

    const classes = useStyles();
    const dispatch = useDispatch();

    return (
        <div className={classes.root}>
            <div style={{display: 'flex', flexDirection: 'row' ,width: '100%', height: '100%'}}>
                <Paper variant='outlined' style={{width: '45%', height: '100%', overflow: 'auto'}}>
                    {props.isLoading ? <div className={classes.center}><CircularProgress color="secondary"/></div> :
                    leftList.length <= 0 ? 
                        <div className={classes.center}>
                            <Typography variant='h6'>{t('batch_order_list_empty')}</Typography>
                            <div>{t('batch_order_list_empty_message')}</div>
                        </div>
                        :
                        <List dense component="div" role="list">
                            {_.sortBy(leftList, ['id']).map((account, index) => {
                                return (
                                    <ListItem key={index} role="listitem" button onClick={()=>handleToggle(account)}>
                                        <ListItemIcon>
                                            <Checkbox 
                                                checked={checked.indexOf(account) !== -1}
                                                tabIndex={-1}
                                                edge="start"
                                            />
                                        </ListItemIcon>
                                        <ListItemText primary={`${getDistrictName(account.id)} (${account.orderIds.length})`} />
                                    </ListItem>
                                )
                            })}
                        </List>
                    }
                </Paper>
                <div style={{display: 'flex', width: '10%', height: '100%'}}>
                    <div style={{display: 'flex', flexDirection: 'column', margin: 'auto'}}>
                        <Button 
                            variant='outlined' 
                            onClick={handleTransferRight}
                            disabled={leftChecked.length === 0}
                        >
                            <ArrowForward /> 
                        </Button>
                        &nbsp;&nbsp;
                        <Button 
                            variant='outlined' 
                            onClick={handleAllRight}
                            disabled={leftList.length <= 0}
                        >
                            <KeyboardTab /> 
                        </Button>
                        &nbsp;&nbsp;
                        <Button 
                            variant='outlined'
                            onClick={handleTransferLeft}
                            disabled={rightChecked.length === 0}
                        >
                            <ArrowBack />
                        </Button>
                        &nbsp;&nbsp;
                        <Tooltip title={t('quick_assign_tooltip')}>
                            <span>
                                <Button 
                                    variant='outlined'
                                    disabled={leftList.length <= 0}
                                    onClick={()=>handleAutoTransfer()}
                                >
                                    <TextRotationNone />
                                </Button>
                            </span>
                        </Tooltip>
                        &nbsp;&nbsp;
                        <Tooltip title={t('reset_tooltip')}>
                            <Button 
                                variant='outlined'
                                onClick={handleReset}
                            >
                                <Refresh /> 
                            </Button>
                        </Tooltip>
                    </div>
                </div>
                <Paper variant='outlined' style={{width: '45%', height: '100%', overflow: 'auto'}}>
                    <RadioGroup value={staffValue} onChange={handleStaffSelection} style={{padding: 8}}>
                        {_.map(props.accounts, function(staffs, key){
                            return (
                                <Accordion key={key} defaultExpanded={true}  style={{width: '100%'}}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                    >
                                        <Typography style={{fontWeight: 'bold', textTransform: 'uppercase'}}>
                                            {getDistrictName(key)}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{flexDirection: 'column'}}>
                                        {_.map(staffs, function(staff, index){
                                            return (
                                                <div key={`staff-${index}`}>
                                                    <FormControlLabel value={staff.id.toString()} key={index} control={<Radio />} label={`${staff.id}.${stripIdFromStaffName(staff.name)}`}/>
                                                    <List key={`list-${index}`} dense component="div" role="list">
                                                        {_.map(_.filter(rightList, function(a){return a['assign_to_account'] == staff.id}), function(item, index){
                                                            return (
                                                                <ListItem key={index} role="listitem" button onClick={()=>handleToggle(item)}>
                                                                    <ListItemIcon>
                                                                        <Checkbox 
                                                                            checked={checked.indexOf(item) !== -1}
                                                                            tabIndex={-1}
                                                                            edge="start"
                                                                        />
                                                                    </ListItemIcon>
                                                                    <ListItemText primary={`${getDistrictName(item.id)} (${item.orderIds.length})`} />
                                                                </ListItem>
                                                            )
                                                        })}
                                                    </List>
                                                </div>
                                            )
                                        })}
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </RadioGroup>
                </Paper>
            </div>
        </div>
    )

    function handleToggle(value) {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];
    
        if (currentIndex === -1) {
          newChecked.push(value);
        } else {
          newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    function handleAutoTransfer(){
        if(leftList.length <= 0){
            return
        }

        let assign = getAutoAssignRightData(props.accounts, leftList)

        setRightList(rightList.concat(assign))
        setLeftList(not(leftList, assign));
        if(leftList.length > 0){
            dispatch(showAlertSnackbar({message: "Some orders cannot be auto assigned! Please manually assign them."}))
        }
    }
      
    function handleTransferRight(){
        let assign = getAssignRightData(leftChecked, staffValue)
        
        setRightList(rightList.concat(assign));
        setLeftList(not(leftList, leftChecked));
        setChecked(not(checked, leftChecked))
    }

    function handleTransferLeft(){
        setLeftList(leftList.concat(rightChecked));
        setRightList(not(rightList, rightChecked));
        setChecked(not(checked, rightChecked));
    }

    function handleAllRight(){
        setRightList(rightList.concat(getAssignRightData(leftList, staffValue)))
        setLeftList([])
        setChecked([])
    }

    function handleReset(){
        setLeftList(props.transferList)
        setRightList([])
        setChecked([])
    }

    function handleStaffSelection(event){
        setStaffValue(event.target.value)
    }

    // function handleMapPreview(orders){
    //     let waypoints = []
    //     _.map(orders, function(order){
    //         waypoints.push({lat: order.lat, lng: order.lng})
    //     })
    //     dispatch(getDirections(waypoints))
    // }

    function getAutoAssignRightData(accounts, list){
        let headAccounts = _.map(accounts, _.head)

        return _.compact(_.map(headAccounts, function(account){
            let index = _.findIndex(list, (left)=>{return left.id == account.district})
            if(index !== -1){
                list[index]['assign_to_account'] = account.id.toString()
                return list[index]
            }
        }))
    }

    function getAssignRightData(list, selectedStaff){
        return _.map(list, function(item){
            return {...item, assign_to_account: selectedStaff.toString()}
        })
    }

    function getDefaultAccount(accounts){
        let account = _.first(_.first(accounts))
        return account && account.id.toString() || []
    }
}

TransferList.defaultProps = {
    transferList: [],
    loadedOrders: [],
    accounts: []
}

export default TransferList